import React from 'react'
import { Bar } from '@nivo/bar'
import cn from 'classnames'
import { COLORS_OPACITY } from '../Reports'

import './styles.scss'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'

export const bc = 'bar-chart'

export const renderColumn = (data, property, title) => {
  return (
    <div className={`${bc}__column`}>
      <div className={`${bc}__title-column`}>{title}</div>
      <div className={`${bc}__avgs`}>
        {data.map((el, i) => (
          <div key={i} className={`${bc}__avg`}>
            {el[property]}
          </div>
        ))}
      </div>
    </div>
  )
}

const CustomTick = tick => {
  return (
    <g transform={`translate(${tick.x - 50},${tick.y})`}>
      <circle cx={-40} cy={0} r={5} fill={COLORS_OPACITY[tick.tickIndex]} />
      <text transform={`translate(-30, 1)`} textAnchor="start" dominantBaseline="middle" className={`${bc}__tick`}>
        {tick.value}
      </text>
    </g>
  )
}

const BarChart = ({ title, data, classNameTitle, subtitle, reviewers }) => {
  // this need for removing empty reviewersTypes
  const updatedData = data.reduce((acc, el) => {
    if (el.reviewerType === 'Supervisors' && reviewers[TYPE_OF_REVIEWERS.SUPERIOR]) {
      acc.push(el)
      return acc
    }
    if (el.reviewerType === 'Peers' && reviewers[TYPE_OF_REVIEWERS.PEER]) {
      acc.push(el)
      return acc
    }
    if (el.reviewerType === 'Direct' && reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]) {
      acc.push(el)
      return acc
    }
    if (el.reviewerType === 'Self') {
      acc.push(el)
      return acc
    }
    return acc
  }, [])
  const reversedData = [...updatedData].reverse()
  return (
    <div className={bc}>
      <span className={cn(`${bc}__title`, { [classNameTitle]: classNameTitle })}>{title}</span>
      {subtitle && <div className={`${bc}__subtitle`}>{subtitle}</div>}
      <div className={`${bc}__chart`}>
        <Bar
          layout="horizontal"
          data={updatedData}
          width={585}
          height={165}
          keys={['avg']}
          indexBy="reviewerType"
          margin={{ top: 30, right: 10, bottom: 20, left: 100 }}
          padding={0.4}
          colors={node => COLORS_OPACITY[node.index]}
          enableGridX
          enableGridY={false}
          enableLabel={false}
          axisBottom={{
            enable: true,
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
          }}
          axisLeft={{
            renderTick: CustomTick,
          }}
          animate
          motionStiffness={90}
          motionDamping={15}
        />
        {renderColumn(reversedData, 'avg', 'Avg')}
        {renderColumn(reversedData, 'teamAvg', 'Team')}
      </div>
    </div>
  )
}

export default BarChart
